import React from 'react';
import PropTypes from 'prop-types';
import Switch from '@material-ui/core/Switch';

import { orange } from "@material-ui/core/colors";
import { withStyles } from "@material-ui/core/styles";

import './index.sass';

const SwitchButton = ({ className, onChange, checked, color }) => {
	const ColoredSwitch = withStyles({
		switchBase: {
			color: color[700],
			"&$checked": {
				color: color[700],
			},
			"&$checked + $track": {
				backgroundColor: color[800],
			},
		},
		checked: {},
		track: {},
	})(Switch);

	return (
		<ColoredSwitch
			className={`SwitchButton ${className}`}
			checked={checked}
			onChange={onChange}
		/>
	);
}

SwitchButton.propTypes = {
	className: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	checked: PropTypes.bool.isRequired,
	color: PropTypes.object
};

SwitchButton.defaultProps = {
	className: "",
	onChange: () => { },
	color: orange
};

export default SwitchButton;
